import React, { useContext, useState } from 'react'
import ProductAttributesList from './CollapsibleAttributes/ProductAttributesList'
import { DocumentsList } from './CollapsibleAttributes/DocumentList'
import { Heading } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const VISIBLE_FILTERS = 12
const VISIBLE_FILTERS_FOR_CLUSTERED_ATTRIBUTES = 3

const Attributes = ({ productDetails, lang, pimAttributesTranslations = {} }) => {
  const { clustered: isAttributesClustered, documents, safetyDocuments, attributes } = productDetails || {}
  const t = useContext(TranslateContext)
  const [isExpanded, setIsExpanded] = useState(false)
  const visibleFiltersCount = isAttributesClustered ? VISIBLE_FILTERS_FOR_CLUSTERED_ATTRIBUTES : VISIBLE_FILTERS
  const documentsVisible = Array.isArray(documents) && documents.length > 0
  const safetyDocumentsVisible = Array.isArray(safetyDocuments) && safetyDocuments.length > 0
  return (
    <div className='mxd-classification-attributes-container'>
      <div data-toggle-active={isExpanded} />
      <Heading size='md'>{t('clustered_attr_list_header')}</Heading>
      <ProductAttributesList
        attributes={attributes}
        isAttributesClustered={isAttributesClustered}
        visibleFiltersCount={visibleFiltersCount}
        lang={lang}
        isOpen={isExpanded}
        setIsOpen={() => setIsExpanded(prevState => !prevState)}
        pimAttributesTranslations={pimAttributesTranslations}
      />
      {(documentsVisible || safetyDocumentsVisible) && (
        <DocumentsList
          documents={documentsVisible ? documents : []}
          safetyDocuments={safetyDocumentsVisible ? safetyDocuments : []}
        />
      )}
    </div>
  )
}

export default Attributes
